/* eslint-disable */

import ResourcePattern from '@/services/resource-patters';

export default ResourcePattern('Version', 'userversions', ({ Api, servicename, resource }) => ({
  actions: {
    async get(_, { params }) {
      const { data, headers } = await Api.get(servicename, resource, { params });
      return {
        data,
        total: Number(headers['x-total-count']),
      };
    },
    async getUsers(_, { params }) {
      const { data } = await Api.get(servicename, `${resource}/users`, { params });
      return {
        data: data?.data ?? [],
        total: data?.total ?? 0,
      };
    },
    async find(_, { id }) {
      const { data } = await Api.get(servicename, `${resource}/${id}`);
      return data;
    },
    async count(_, { params }) {
      const { data } = await Api.get(servicename, `${resource}/count`, { params });
      return data;
    },
    async delete(_, { id }) {
      await Api.delete(servicename, `${resource}/${id}`);
    },
    async create(_, { dataForm }) {
      const { data } = await Api.post(servicename, `${resource}`, dataForm);
      return data;
    },
    async update(_, { id, dataForm }) {
      const { data } = await Api.patch(servicename, `${resource}/${id}`, dataForm);
      return data;
    },
    async downloadCsv(_, { params }) {
      const { data } = await Api.get(servicename, `${resource}/export-csv`, { params });
      return data;
    },
  },
}));
/* eslint-enable */
